/* Hook & Barrel â€” theme behavior (vanilla JS, no build step) */
(function () {

  var section =
    document.getElementById(
      'HBProduct-{{ section.id }}'
    );
  if (!section) {
    return;
  }

  var giftFields =
    section.querySelector(
      '[data-product-gift-fields]'
    );

  if (!giftFields) {
    return;
  }

  var productForm =
    section.querySelector(
      '[data-product-form]'
    );

  if (!productForm) {
    return;
  }

  var variantInput =
    productForm.querySelector(
      'input[name="id"]'
    );

  if (!variantInput) {
    return;
  }
  var variantsElement =
    document.getElementById(
      'HBGiftVariants-{{ section.id }}'
    );

  if (!variantsElement) {
    return;
  }

  var variants = [];
  try {
    variants =
      JSON.parse(
        variantsElement.textContent
      );
  } catch (error) {
    return;
  }

  /* ==========================================================
     SETTINGS
  ========================================================== */

  var scope =
    giftFields.getAttribute(
      'data-gift-scope'
    ) || 'variant';

  var variantNamesRaw =
    giftFields.getAttribute(
      'data-gift-variant-names'
    ) || '';

  var variantNames =
    variantNamesRaw
      .split(',')
      .map(function (name) {
        return name
          .trim()
          .toLowerCase();
      })
      .filter(function (name) {
        return name !== '';
      });

  /* ==========================================================
     FIND CURRENT VARIANT
  ========================================================== */

  function getCurrentVariant() {
    var variantId =
      parseInt(
        variantInput.value,
        10
      );
    if (!variantId) {
      return null;
    }
    return variants.find(
      function (variant) {
        return Number(variant.id) === variantId;
      }
    ) || null;
  }

  /* ==========================================================
     SHOULD SHOW FIELDS?
  ========================================================== */

  function shouldShowGiftFields() {
    /*
     * Product mode:
     * always show for this product.
     */
    if (scope === 'product') {
      return true;
    }
    /*
     * Variant mode.
     */
    if (scope !== 'variant') {
      return false;
    }
    var variant =
      getCurrentVariant();
    if (!variant) {
      return false;
    }
    var currentTitle =
      String(
        variant.title || ''
      )
      .trim()
      .toLowerCase();
    return variantNames.indexOf(
      currentTitle
    ) !== -1;
  }
  /* ==========================================================
     SHOW / HIDE
  ========================================================== */
  function updateGiftFields() {
    var shouldShow =
      shouldShowGiftFields();
    giftFields.hidden =
      !shouldShow;
    giftFields
      .querySelectorAll(
        '[data-gift-input]'
      )
      .forEach(
        function (field) {
          field.disabled =
            !shouldShow;
        }
      );
  }
  /* ==========================================================
     VARIANT CHANGE

     Your existing variant picker updates input[name="id"].
     Running on next tick ensures we read the newly selected
     variant ID rather than the previous one.
  ========================================================== */

  productForm.addEventListener(
    'change',
    function (event) {


      /*
       * Ignore changes made inside our own gift fields.
       */
      if (
        event.target.closest(
          '[data-product-gift-fields]'
        )
      ) {
        return;
      }
      window.setTimeout(
        updateGiftFields,
        0
      );
    }
  );
  updateGiftFields();

})();
(function () {
    'use strict';

    var fetchOpts = { credentials: 'same-origin' };

    /* ---------------- Announcement bar rotation ---------------- */
    function initAnnouncementBar() {
        var bar = document.querySelector('[data-announcement-bar]');
        if (!bar) return;
        var slides = bar.querySelectorAll('[data-announcement-slide]');
        if (slides.length < 2 || bar.getAttribute('data-autoplay') !== 'true') return;
        var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4000;
        var i = 0;
        setInterval(function () {
            slides[i].classList.remove('is-active');
            i = (i + 1) % slides.length;
            slides[i].classList.add('is-active');
        }, speed);
    }

    /* ---------------- Mobile menu drawer ---------------- */
    function initMobileMenu() {
        var drawer = document.getElementById('MobileMenuDrawer');
        if (!drawer) return;
        var openers = document.querySelectorAll('[data-header-menu-open]');
        var closers = drawer.querySelectorAll('[data-header-menu-close]');
        openers.forEach(function (btn) {
            btn.addEventListener('click', function () {
                drawer.classList.add('is-open');
                drawer.setAttribute('aria-hidden', 'false');
                btn.setAttribute('aria-expanded', 'true');
                document.body.style.overflow = 'hidden';
            });
        });
        closers.forEach(function (btn) {
            btn.addEventListener('click', closeMobileMenu);
        });
        function closeMobileMenu() {
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }
    }

    /* ---------------- Cart drawer ---------------- */
    var cartDrawer = null;

    function getCartDrawer() {
        if (!cartDrawer) cartDrawer = document.getElementById('CartDrawer');
        return cartDrawer;
    }

    function openCartDrawer() {
        var drawer = getCartDrawer();
        if (!drawer) { window.location.href = '/cart'; return; }
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }

    function closeCartDrawer() {
        var drawer = getCartDrawer();
        if (!drawer) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    function initCartDrawer() {
        var drawer = getCartDrawer();
        if (!drawer) return;

        /*
         * Use event delegation because the cart drawer contents are replaced
         * after Ajax cart updates. Direct listeners on the original close
         * buttons would be lost when drawer.innerHTML is refreshed.
         */
        document.addEventListener('click', function (e) {
            var closeButton = e.target.closest('[data-cart-drawer-close]');
            if (!closeButton || !drawer.contains(closeButton)) return;
            e.preventDefault();
            closeCartDrawer();
        });

        document.querySelectorAll('[data-cart-icon-link]').forEach(function (link) {
            if (document.body.dataset.cartType !== 'drawer') return;
            link.addEventListener('click', function (e) {
                e.preventDefault();
                openCartDrawer();
            });
        });
    }

    function refreshCartDrawerMarkup(html) {
        var drawer = getCartDrawer();
        if (!drawer || !html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
        }

        var freshBubble = doc.querySelector('[data-cart-icon-bubble]');
        if (freshBubble) {
            document.querySelectorAll('[data-cart-icon-bubble]').forEach(function (el) {
                el.textContent = freshBubble.textContent;
            });
        }
    }

    function updateCartIconCount(count) {
        document.querySelectorAll('[data-cart-icon-bubble]').forEach(function (el) {
            el.textContent = count;
        });
    }

/* ---------------- Add to cart (product forms) ---------------- */

function initProductForms(root) {
    root = root || document;

    var forms = [];

    if (
        root.matches &&
        root.matches('[data-product-form]')
    ) {
        forms.push(root);
    }

    root
        .querySelectorAll('[data-product-form]')
        .forEach(function (form) {
            forms.push(form);
        });


    forms.forEach(function (form) {

        /*
         * Prevent duplicate listeners when the same
         * content is initialized more than once.
         */
        if (form.dataset.hbProductFormBound === 'true') {
            return;
        }

        form.dataset.hbProductFormBound = 'true';


        form.addEventListener('submit', function (e) {

            e.preventDefault();

            var submitBtn =
                form.querySelector('[type="submit"]');

            var errorEl =
                form.querySelector('[data-form-error]');


            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.classList.add('is-loading');
            }

            if (errorEl) {
                errorEl.textContent = '';
            }


            prepareQuickViewSellingPlans(form)
                .catch(function () {})
                .then(function () {
            var quickView = form.closest('[data-hb-quick-view]');
            var formData = new FormData(form);
            var request;

            /*
             * Appstle wraps fetch and, for FormData posts to /cart/add,
             * sets selling_plan from the subscription widget already on
             * the page. A JSON items payload is left alone when the
             * variant is not the open product, so the popup can add
             * its own item without that plan.
             */
            if (quickView) {
                applyQuickViewSellingPlan(form, formData);
                request = fetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    },
                    body: JSON.stringify(buildQuickViewCartBody(formData))
                });
            } else {
                formData.set('sections', 'cart-drawer');
                formData.set('sections_url', window.location.pathname);
                request = fetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData
                });
            }

            if (!request || typeof request.then !== 'function') {
                request = Promise.reject({
                    description: 'This item could not be added to your cart.'
                });
            }

            return request

                .then(function (res) {
                    return res.json()
                        .then(function (data) {

                            if (!res.ok) {
                                throw data;
                            }

                            return data;
                        });
                })

                .then(function (data) {

                    /*
                     * If this form came from Quick View,
                     * close Quick View before opening
                     * the cart drawer.
                     */
                    var quickView =
                        form.closest(
                            '[data-hb-quick-view]'
                        );

                    if (quickView) {
                        quickView.classList.remove(
                            'is-open'
                        );

                        quickView.setAttribute(
                            'aria-hidden',
                            'true'
                        );

                        document.body.style.overflow = '';
                    }


                    if (
                        data.sections &&
                        data.sections['cart-drawer']
                    ) {
                        refreshCartDrawerMarkup(
                            data.sections['cart-drawer']
                        );
                    } else {
                        openCartDrawer();
                    }


                    return fetch(
                        '/cart.js',
                        fetchOpts
                    );
                })

                .then(function (response) {

                    if (!response) {
                        return null;
                    }

                    return response.json();
                })

                .then(function (cart) {

                    if (cart) {
                        updateCartIconCount(
                            cart.item_count
                        );
                    }
                })

                .catch(function (error) {

                    if (errorEl) {
                        errorEl.textContent =
                            error.description ||
                            error.message ||
                            'This item could not be added to your cart.';
                    }
                })

                .finally(function () {

                    if (submitBtn) {
                        submitBtn.disabled = false;

                        submitBtn.classList.remove(
                            'is-loading'
                        );
                    }
                });
                });
        });
    });
}

    /* ---------------- Quantity steppers (generic) ---------------- */
    function initQuantitySteppers() {
        document.addEventListener('click', function (e) {
            var incBtn = e.target.closest('[data-qty-increase]');
            var decBtn = e.target.closest('[data-qty-decrease]');
            if (!incBtn && !decBtn) return;
            var wrap = (incBtn || decBtn).closest('[data-quantity-stepper]');
            if (!wrap) return;
            var input = wrap.querySelector('[data-qty-input]');
            if (!input) return;
            var min = parseInt(input.min, 10) || 1;
            var max = input.max ? parseInt(input.max, 10) : Infinity;
            var val = parseInt(input.value, 10) || min;
            val = incBtn ? Math.min(max, val + 1) : Math.max(min, val - 1);
            input.value = val;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    /* ---------------- Cart page / drawer line quantity + remove (Ajax Cart API) ---------------- */
    function initCartLineSync() {
        document.addEventListener('change', function (e) {
            var input = e.target.closest('[data-cart-line] [data-qty-input]');
            if (!input) return;
            var line = input.closest('[data-cart-line]');
            var key = line.getAttribute('data-cart-key');
            updateCartLine(key, parseInt(input.value, 10) || 1, line);
        });
        document.addEventListener('click', function (e) {
            var removeBtn = e.target.closest('[data-cart-remove]');
            if (!removeBtn) return;
            e.preventDefault();
            updateCartLine(removeBtn.getAttribute('data-cart-remove'), 0, removeBtn.closest('[data-cart-line]'));
        });
    }

    function updateCartLine(key, quantity, lineEl) {
        if (lineEl) lineEl.classList.add('is-updating');
        fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
        })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
                updateCartIconCount(cart.item_count);
                var drawer = getCartDrawer();
                var drawerOpen = drawer && drawer.classList.contains('is-open');
                if (window.location.pathname.indexOf('/cart') === 0 && !drawerOpen) {
                    window.location.reload();
                    return;
                }
                if (cart.sections && cart.sections['cart-drawer']) {
                    refreshCartDrawerMarkup(cart.sections['cart-drawer']);
                }
            })
            .catch(function () {
                if (lineEl) lineEl.classList.remove('is-updating');
            });
    }

    /* ==========================================================
     CART UPSELL CAROUSEL
     ========================================================== */

    var cartUpsellsInitialized = false;


    function initCartUpsells() {

        /*
         * We use event delegation because #CartDrawer innerHTML
         * is replaced after every Ajax cart update.
         */

        if (cartUpsellsInitialized) {
            return;
        }


        cartUpsellsInitialized = true;



        /* ========================================================
           CLICK EVENTS
        ======================================================== */

        document.addEventListener(
            'click',
            function (e) {


                /* ====================================================
                   PREVIOUS
                ==================================================== */

                var previousButton =
                    e.target.closest(
                        '[data-cart-upsell-prev]'
                    );


                if (previousButton) {

                    e.preventDefault();


                    scrollCartUpsells(
                        previousButton,
                        -1
                    );


                    return;

                }



                /* ====================================================
                   NEXT
                ==================================================== */

                var nextButton =
                    e.target.closest(
                        '[data-cart-upsell-next]'
                    );


                if (nextButton) {

                    e.preventDefault();


                    scrollCartUpsells(
                        nextButton,
                        1
                    );


                    return;

                }



                /* ====================================================
                   ADD UPSELL
                ==================================================== */

                var addButton =
                    e.target.closest(
                        '[data-cart-upsell-add]'
                    );


                if (!addButton) {
                    return;
                }


                e.preventDefault();


                addCartUpsell(
                    addButton
                );

            }
        );

    }



    /* ==========================================================
       SCROLL CAROUSEL
       ========================================================== */

    function scrollCartUpsells(
        button,
        direction
    ) {

        var upsells =
            button.closest(
                '[data-cart-upsells]'
            );


        if (!upsells) {
            return;
        }


        var track =
            upsells.querySelector(
                '[data-cart-upsell-track]'
            );


        if (!track) {
            return;
        }


        var card =
            track.querySelector(
                '[data-cart-upsell-card]'
            );


        var amount =
            track.clientWidth * 0.8;


        if (card) {

            var cardWidth =
                card.getBoundingClientRect()
                    .width;


            var trackStyle =
                window.getComputedStyle(
                    track
                );


            var gap =
                parseFloat(
                    trackStyle.columnGap ||
                    trackStyle.gap
                ) || 12;


            amount =
                cardWidth + gap;

        }


        var reducedMotion =
            window.matchMedia &&
            window.matchMedia(
                '(prefers-reduced-motion: reduce)'
            ).matches;


        track.scrollBy({
            left:
                amount *
                direction,

            behavior:
                reducedMotion
                    ? 'auto'
                    : 'smooth'
        });

    }



    /* ==========================================================
       ADD UPSELL PRODUCT
       ========================================================== */

    function addCartUpsell(button) {

    if (
        !button ||
        button.disabled
    ) {

        return;

    }


    var variantId =
        button.getAttribute(
            'data-variant-id'
        );


    if (!variantId) {
        return;
    }



    var insideCartPage =
        !!button.closest(
            '.hb-cart-page'
        );


    var insideCartDrawer =
        !!button.closest(
            '#CartDrawer'
        );



    var buttonText =
        button.querySelector(
            '[data-cart-upsell-button-text]'
        );


    var originalText =
        buttonText
            ? buttonText.textContent
            : 'Add';



    /* ========================================================
       LOADING
    ======================================================== */

    button.disabled = true;


    button.classList.add(
        'is-loading'
    );


    if (buttonText) {

        buttonText.textContent =
            'Adding...';

    }



    /* ========================================================
       FORM DATA
    ======================================================== */

    var formData =
        new FormData();


    formData.append(
        'id',
        variantId
    );


    formData.append(
        'quantity',
        '1'
    );



    /*
     * Drawer needs freshly rendered cart-drawer markup.
     *
     * Cart page will reload after successful add, so there
     * is no need to request cart-drawer HTML there.
     */

    if (insideCartDrawer) {

        formData.append(
            'sections',
            'cart-drawer'
        );


        formData.append(
            'sections_url',
            window.location.pathname
        );

    }



    /* ========================================================
       ADD PRODUCT
    ======================================================== */

    fetch(
        '/cart/add.js',
        {
            method:
                'POST',

            credentials:
                'same-origin',

            body:
                formData
        }
    )


    .then(function (response) {

        return response
            .json()
            .then(function (data) {

                if (!response.ok) {

                    throw data;

                }


                return data;

            });

    })


    .then(function (data) {


        /* ====================================================
           CART PAGE
        ==================================================== */

        if (insideCartPage) {

            window.location.reload();

            return null;

        }



        /* ====================================================
           CART DRAWER
        ==================================================== */

        if (
            insideCartDrawer &&
            data.sections &&
            data.sections[
                'cart-drawer'
            ]
        ) {

            refreshCartDrawerMarkup(
                data.sections[
                    'cart-drawer'
                ]
            );

        }

        else if (insideCartDrawer) {

            openCartDrawer();

        }



        /* ====================================================
           FETCH CART COUNT
        ==================================================== */

        return fetch(
            '/cart.js',
            fetchOpts
        );

    })


    .then(function (response) {

        if (!response) {
            return null;
        }


        return response.json();

    })


    .then(function (cart) {

        if (!cart) {
            return;
        }


        updateCartIconCount(
            cart.item_count
        );

    })


    .catch(function (error) {


        if (
            document.body.contains(
                button
            )
        ) {

            button.disabled = false;


            button.classList.remove(
                'is-loading'
            );


            if (buttonText) {

                buttonText.textContent =
                    error &&
                    error.description
                        ? error.description
                        : 'Try again';

            }


            window.setTimeout(
                function () {

                    if (
                        !document.body.contains(
                            button
                        )
                    ) {

                        return;

                    }


                    if (buttonText) {

                        buttonText.textContent =
                            originalText;

                    }

                },
                1800
            );

        }

    })


    .finally(function () {


        if (
            !document.body.contains(
                button
            )
        ) {

            return;

        }


        button.disabled = false;


        button.classList.remove(
            'is-loading'
        );

    });

}

    /* ==========================================================
     CART SUBSCRIPTION UPGRADE
     Seal Subscriptions / Shopify Selling Plans
  ========================================================== */

    /* ==========================================================
   CART SUBSCRIPTION UPDATE
   Seal Subscriptions / Shopify Selling Plans
========================================================== */

function initCartSubscriptionUpgrade() {

    /*
     * Prevent duplicate delegated listeners if this
     * initializer is ever called more than once.
     */

    if (initCartSubscriptionUpgrade.initialized) {
        return;
    }

    initCartSubscriptionUpgrade.initialized = true;


    document.addEventListener(
        'change',
        function (event) {

            var select =
                event.target.closest(
                    '[data-cart-subscription-select]'
                );


            if (!select) {
                return;
            }



            /* ====================================================
               SELECTED SELLING PLAN
            ==================================================== */

            var sellingPlanId =
                select.value;


            /*
             * Empty value is currently the placeholder:
             *
             * <option value="">
             *   Choose subscription
             * </option>
             *
             * So do nothing.
             */

            if (!sellingPlanId) {
                return;
            }



            /* ====================================================
               CART LINE INFORMATION
            ==================================================== */

            var lineNumber =
                parseInt(
                    select.getAttribute(
                        'data-cart-line-number'
                    ),
                    10
                );


            var quantity =
                parseInt(
                    select.getAttribute(
                        'data-cart-quantity'
                    ),
                    10
                ) || 1;


            if (!lineNumber) {
                return;
            }



            /* ====================================================
               ELEMENTS
            ==================================================== */

            var wrapper =
                select.closest(
                    '[data-cart-subscription-upgrade]'
                );


            var cartLine =
                select.closest(
                    '[data-cart-line]'
                );


            var errorElement =
                wrapper
                    ? wrapper.querySelector(
                        '[data-cart-subscription-error]'
                    )
                    : null;



            /* ====================================================
               DETERMINE LOCATION

               Drawer:
               update drawer markup only.

               Cart page:
               reload page after update so totals, prices,
               discounts and subscription data all refresh.
            ==================================================== */

            var insideCartDrawer =
                !!select.closest(
                    '#CartDrawer'
                );


            var insideCartPage =
                !!select.closest(
                    '.hb-cart-page'
                );



            /* ====================================================
               LOADING STATE
            ==================================================== */

            select.disabled = true;


            if (wrapper) {

                wrapper.classList.add(
                    'is-loading'
                );

            }


            if (cartLine) {

                cartLine.classList.add(
                    'is-updating'
                );

            }


            if (errorElement) {

                errorElement.hidden = true;

                errorElement.textContent = '';

            }



            /* ====================================================
               LOCALE-AWARE SHOPIFY ROUTES
            ==================================================== */

            var root =
                window.Shopify &&
                window.Shopify.routes &&
                window.Shopify.routes.root
                    ? window.Shopify.routes.root
                    : '/';


            var changeUrl =
                root + 'cart/change.js';



            /* ====================================================
               REQUEST DATA
            ==================================================== */

            var requestData = {

                line:
                    lineNumber,

                quantity:
                    quantity,

                selling_plan:
                    parseInt(
                        sellingPlanId,
                        10
                    )

            };


            /*
             * Only request the cart-drawer section when
             * the dropdown is actually inside the drawer.
             *
             * On /cart we will reload the whole page,
             * so rendering cart-drawer HTML is unnecessary.
             */

            if (insideCartDrawer) {

                requestData.sections =
                    'cart-drawer';


                requestData.sections_url =
                    window.location.pathname;

            }



            /* ====================================================
               UPDATE SELLING PLAN
            ==================================================== */

            fetch(
                changeUrl,
                {
                    method:
                        'POST',

                    credentials:
                        'same-origin',

                    headers: {

                        'Content-Type':
                            'application/json',

                        'Accept':
                            'application/json'

                    },

                    body:
                        JSON.stringify(
                            requestData
                        )
                }
            )


            /* ====================================================
               PARSE RESPONSE
            ==================================================== */

            .then(function (response) {

                return response
                    .json()
                    .then(function (data) {

                        if (!response.ok) {

                            throw data;

                        }


                        return data;

                    });

            })


            /* ====================================================
               SUCCESS
            ==================================================== */

            .then(function (cart) {


                /* ================================================
                   CART COUNT
                ================================================ */

                if (
                    typeof cart.item_count !==
                    'undefined'
                ) {

                    updateCartIconCount(
                        cart.item_count
                    );

                }



                /* ================================================
                   CART PAGE

                   Reload the cart page because changing a
                   selling plan can change:

                   - line price
                   - subtotal
                   - discounts
                   - subscription allocation
                   - checkout information
                ================================================ */

                if (insideCartPage) {

                    window.location.reload();

                    return;

                }



                /* ================================================
                   CART DRAWER

                   Shopify returned freshly rendered drawer HTML.

                   Once the selected item has:
                   item.selling_plan_allocation

                   your Liquid will automatically switch from
                   the upgrade dropdown to subscription status.
                ================================================ */

                if (
                    insideCartDrawer &&
                    cart.sections &&
                    cart.sections[
                        'cart-drawer'
                    ]
                ) {

                    refreshCartDrawerMarkup(
                        cart.sections[
                            'cart-drawer'
                        ]
                    );

                    return;

                }



                /* ================================================
                   FALLBACK

                   If Shopify didn't return section HTML for
                   some reason, fetch current cart and keep the
                   drawer open.
                ================================================ */

                if (insideCartDrawer) {

                    fetch(
                        root + 'cart.js',
                        {
                            credentials:
                                'same-origin',

                            headers: {
                                'Accept':
                                    'application/json'
                            }
                        }
                    )

                    .then(function (response) {

                        return response.json();

                    })

                    .then(function (freshCart) {

                        if (
                            typeof freshCart.item_count !==
                            'undefined'
                        ) {

                            updateCartIconCount(
                                freshCart.item_count
                            );

                        }


                        openCartDrawer();

                    })

                    .catch(function () {

                        openCartDrawer();

                    });

                }

            })


            /* ====================================================
               ERROR
            ==================================================== */

            .catch(function (error) {


                select.disabled = false;


                if (wrapper) {

                    wrapper.classList.remove(
                        'is-loading'
                    );

                }


                if (cartLine) {

                    cartLine.classList.remove(
                        'is-updating'
                    );

                }


                if (errorElement) {

                    var message =
                        'Unable to update subscription. Please try again.';


                    if (
                        error &&
                        error.description
                    ) {

                        message =
                            error.description;

                    }

                    else if (
                        error &&
                        error.message
                    ) {

                        message =
                            error.message;

                    }


                    errorElement.textContent =
                        message;


                    errorElement.hidden =
                        false;

                }

            })


            /* ====================================================
               CLEANUP
            ==================================================== */

            .finally(function () {


                /*
                 * If the drawer was refreshed or the cart page
                 * reloaded, this old element may no longer exist.
                 */

                if (
                    !document.body.contains(
                        select
                    )
                ) {

                    return;

                }


                select.disabled = false;


                if (wrapper) {

                    wrapper.classList.remove(
                        'is-loading'
                    );

                }


                if (cartLine) {

                    cartLine.classList.remove(
                        'is-updating'
                    );

                }

            });

        }
    );

}
    /* ---------------- Accordion (FAQ, PDP details) ---------------- */
    function initAccordions() {
        document.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-accordion-trigger]');
            if (!trigger) return;
            var item = trigger.closest('[data-accordion-item]');
            if (!item) return;
            var group = item.closest('[data-accordion-group]');
            var wasOpen = item.classList.contains('is-open');
            if (group && group.getAttribute('data-accordion-single') === 'true') {
                group.querySelectorAll('[data-accordion-item].is-open').forEach(function (openItem) {
                    if (openItem !== item) openItem.classList.remove('is-open');
                });
            }
            item.classList.toggle('is-open', !wasOpen);
        });
    }

    /* ---------------- Product gallery thumbnails ---------------- */
    function initGalleries() {
        document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
            var main = gallery.querySelector('[data-gallery-main]');
            gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
                thumb.addEventListener('click', function () {
                    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
                    thumb.classList.add('is-active');
                    if (main) {
                        var full = thumb.getAttribute('data-full-src');
                        var alt = thumb.getAttribute('data-full-alt');
                        if (full) {
                            var img = main.querySelector('img');
                            if (img) { img.src = full; if (alt) img.alt = alt; }
                        }
                    }
                });
            });
        });
    }

    /* ---------------- Variant picker ---------------- */

function initVariantPickers(root) {
    root = root || document;

    var pickers = [];

    if (
        root.matches &&
        root.matches('[data-variant-picker]')
    ) {
        pickers.push(root);
    }

    root
        .querySelectorAll('[data-variant-picker]')
        .forEach(function (picker) {
            pickers.push(picker);
        });


    pickers.forEach(function (picker) {

        /*
         * Prevent duplicate listeners.
         */
        if (
            picker.dataset.hbVariantPickerBound ===
            'true'
        ) {
            return;
        }

        picker.dataset.hbVariantPickerBound =
            'true';


        var jsonEl =
            picker.querySelector(
                '[data-variant-json]'
            );

        if (!jsonEl) {
            return;
        }


        var variants;

        try {
            variants =
                JSON.parse(
                    jsonEl.textContent
                );
        } catch (err) {
            return;
        }


        var form =
            picker.closest('form');


        var productRoot =
            picker.closest(
                '[data-hb-main-product]'
            ) ||
            form ||
            picker.parentElement;


        var idInput =
            form
                ? form.querySelector(
                    '[name="id"]'
                )
                : null;


        /*
         * IMPORTANT:
         * Find prices inside THIS product only.
         *
         * Previously you used:
         * document.querySelector('[data-product-price]')
         *
         * which could target the main PDP instead
         * of Quick View.
         */
        var priceEls =
            productRoot
                ? productRoot.querySelectorAll(
                    '[data-product-price]'
                )
                : [];


        var addBtn =
            form
                ? form.querySelector(
                    '[data-add-to-cart-btn]'
                )
                : null;


        var addBtnText =
            addBtn
                ? addBtn.querySelector(
                    '[data-add-to-cart-text]'
                )
                : null;


        function currentSelection() {

            var options = [];

            picker
                .querySelectorAll(
                    '[data-option-position]'
                )
                .forEach(function (group) {

                    var checked =
                        group.querySelector(
                            'input[data-option-input]:checked'
                        );

                    options.push(
                        checked
                            ? checked.value
                            : null
                    );
                });

            return options;
        }


        function findVariant() {

            var selected =
                currentSelection();

            return variants.find(
                function (variant) {

                    return variant.options.every(
                        function (option, index) {
                            return (
                                option ===
                                selected[index]
                            );
                        }
                    );
                }
            );
        }


        function update() {

            var variant =
                findVariant();


            if (!variant) {

                if (addBtn) {
                    addBtn.setAttribute(
                        'disabled',
                        'disabled'
                    );
                }

                if (addBtnText) {
                    addBtnText.textContent =
                        'Unavailable';
                }

                return;
            }


            /*
             * Update actual variant submitted.
             */
            if (idInput) {
                idInput.value =
                    variant.id;

                /*
                 * Let any subscription/add-on scripts
                 * know that the variant changed.
                 */
                idInput.dispatchEvent(
                    new Event(
                        'change',
                        {
                            bubbles: true
                        }
                    )
                );
            }


            /*
             * Update only THIS product's price.
             */
            priceEls.forEach(
                function (priceEl) {
                    priceEl.textContent =
                        formatMoney(
                            variant.price
                        );
                }
            );


            if (addBtn) {

                if (variant.available) {

                    addBtn.removeAttribute(
                        'disabled'
                    );

                    if (addBtnText) {
                        addBtnText.textContent =
                            addBtn.getAttribute(
                                'data-add-text'
                            ) ||
                            'Add to cart';
                    }

                } else {

                    addBtn.setAttribute(
                        'disabled',
                        'disabled'
                    );

                    if (addBtnText) {
                        addBtnText.textContent =
                            'Sold out';
                    }
                }
            }
        }


        picker.addEventListener(
            'change',
            update
        );

        update();
    });
}

    function formatMoney(cents, format) {
    var moneyFormat = format || (
        window.Shopify && window.Shopify.money_format
    ) || '${{amount}}';

    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholderRegex);

    if (!match) return moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision === undefined ? 2 : precision;
        thousands = thousands === undefined ? ',' : thousands;
        decimal = decimal === undefined ? '.' : decimal;

        if (number == null || isNaN(number)) return '0';

        var parts = (number / 100).toFixed(precision).split('.');
        var dollars = parts[0].replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            '$1' + thousands
        );
        var fraction = parts[1] ? decimal + parts[1] : '';

        return dollars + fraction;
    }

    var value = '';

    switch (match[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        default:
            return moneyFormat;
    }

    return moneyFormat.replace(placeholderRegex, value);
}

    /* ---------------- Popup (scroll / exit-intent) ---------------- */
    function initPopup() {
        var popup = document.querySelector('[data-email-popup]');
        if (!popup) return;
        var trigger = popup.getAttribute('data-trigger') || 'scroll';
        var scrollPct = parseInt(popup.getAttribute('data-scroll-percent'), 10) || 45;
        var storageKey = 'hb_popup_dismissed';
        if (sessionStorage.getItem(storageKey)) return;
        var shown = false;

        function show() {
            if (shown) return;
            shown = true;
            popup.classList.add('is-open');
            popup.setAttribute('aria-hidden', 'false');
        }
        function dismiss() {
            popup.classList.remove('is-open');
            popup.setAttribute('aria-hidden', 'true');
            sessionStorage.setItem(storageKey, '1');
        }
        popup.querySelectorAll('[data-popup-close]').forEach(function (el) { el.addEventListener('click', dismiss); });

        if (trigger === 'scroll' || trigger === 'both') {
            window.addEventListener('scroll', function () {
                var pct = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
                if (pct >= scrollPct) show();
            });
        }
        if (trigger === 'exit_intent' || trigger === 'both') {
            document.addEventListener('mouseout', function (e) {
                if (!e.relatedTarget && e.clientY < 10) show();
            });
        }
    }

    /* ---------------- Video modal ---------------- */
    function initVideoModal() {
        document.querySelectorAll('[data-video-modal-open]').forEach(function (opener) {
            opener.addEventListener('click', function () {
                var modal = document.getElementById(opener.getAttribute('data-video-modal-open'));
                if (modal) { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); }
            });
        });
        document.querySelectorAll('[data-video-modal]').forEach(function (modal) {
            modal.querySelectorAll('[data-video-modal-close]').forEach(function (closer) {
                closer.addEventListener('click', function () {
                    modal.classList.remove('is-open');
                    modal.setAttribute('aria-hidden', 'true');
                });
            });
        });
    }

    /* ---------------- Native product recommendations ---------------- */
    function initRecommendations() {
        document.querySelectorAll('[data-recommendations]').forEach(function (el) {
            var url = el.getAttribute('data-url');
            if (!url) return;
            fetch(url)
                .then(function (res) { return res.text(); })
                .then(function (html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    var fresh = doc.querySelector('[data-recommendations]');
                    if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
                })
                .catch(function () { });
        });
    }

    /* ---------------- Init ---------------- */
/* ---------------- Init ---------------- */
/* ---------------- Dynamically loaded Quick View ---------------- */

function toProductJsUrl(productUrl) {
    try {
        var url = new URL(productUrl, window.location.origin);
        url.search = '';
        url.hash = '';
        if (!/\.js$/.test(url.pathname)) {
            url.pathname = url.pathname.replace(/\/$/, '') + '.js';
        }
        return url.pathname;
    } catch (error) {
        return String(productUrl || '')
            .split('?')[0]
            .split('#')[0]
            .replace(/\/$/, '') + '.js';
    }
}

function isolateQuickViewIds(container) {
    if (!container || !container.querySelectorAll) {
        return;
    }

    var suffix = '-hbqv-' + Math.random().toString(36).slice(2, 8);
    var nodes = Array.prototype.slice.call(container.querySelectorAll('[id]'));
    var idMap = {};

    nodes.forEach(function (node) {
        idMap[node.id] = node.id + suffix;
    });

    nodes.forEach(function (node) {
        if (idMap[node.id]) {
            node.id = idMap[node.id];
        }
    });

    container.querySelectorAll('[form], [for], [aria-controls], [aria-labelledby]').forEach(function (node) {
        ['form', 'for', 'aria-controls', 'aria-labelledby'].forEach(function (attr) {
            var value = node.getAttribute(attr);
            if (value && idMap[value]) {
                node.setAttribute(attr, idMap[value]);
            }
        });
    });
}

function rememberQuickViewSellingPlans(container, productUrl) {
    window.HBQuickViewVariantPlans = window.HBQuickViewVariantPlans || {};
    window.HBQuickViewSellingPlanRequests = window.HBQuickViewSellingPlanRequests || {};

    var productRoot = container && container.querySelector
        ? container.querySelector('[data-hb-main-product]')
        : null;
    var productId = productRoot
        ? String(productRoot.getAttribute('data-product-id') || '')
        : '';

    if (!productId || !productUrl) {
        return Promise.resolve();
    }

    if (window.HBQuickViewVariantPlans[productId]) {
        return Promise.resolve();
    }

    if (window.HBQuickViewSellingPlanRequests[productId]) {
        return window.HBQuickViewSellingPlanRequests[productId];
    }

    var request = fetch(toProductJsUrl(productUrl), {
        credentials: 'same-origin'
    })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Could not load product plans.');
            }
            return response.json();
        })
        .then(function (product) {
            var byVariant = {};

            (product.variants || []).forEach(function (variant) {
                byVariant[String(variant.id)] = {
                    requiresSellingPlan: !!variant.requires_selling_plan,
                    planIds: (variant.selling_plan_allocations || []).map(function (allocation) {
                        return String(allocation.selling_plan_id || '');
                    }).filter(Boolean)
                };
            });

            var resolvedId = String(product.id || productId);
            window.HBQuickViewVariantPlans[resolvedId] = byVariant;
            window.HBQuickViewVariantPlans[productId] = byVariant;
        })
        .catch(function () {
            window.HBQuickViewVariantPlans[productId] =
                window.HBQuickViewVariantPlans[productId] || {};
        });

    window.HBQuickViewSellingPlanRequests[productId] = request;
    return request;
}

function prepareQuickViewSellingPlans(form) {
    if (!form.closest('[data-hb-quick-view]')) {
        return Promise.resolve();
    }

    var productRoot = form.closest('[data-hb-main-product]');
    var productId = productRoot
        ? String(productRoot.getAttribute('data-product-id') || '')
        : '';
    var requests = window.HBQuickViewSellingPlanRequests || {};

    return requests[productId] || Promise.resolve();
}

function pageSellingPlanIds(form) {
    var ids = [];

    document.querySelectorAll('[name="selling_plan"]').forEach(function (field) {
        if (form.contains(field)) {
            return;
        }

        var value = String(field.value || '').trim();
        if (value && ids.indexOf(value) === -1) {
            ids.push(value);
        }
    });

    return ids;
}

function buildQuickViewCartBody(formData) {
    var item = {
        id: Number(formData.get('id')),
        quantity: Math.max(1, Number(formData.get('quantity') || 1))
    };
    var plan = String(formData.get('selling_plan') || '').trim();
    var properties = {};

    if (plan) {
        item.selling_plan = Number(plan);
    }

    formData.forEach(function (value, key) {
        var match = String(key).match(/^properties\[(.+)\]$/);
        if (match) {
            properties[match[1]] = String(value);
        }
    });

    if (Object.keys(properties).length) {
        item.properties = properties;
    }

    return {
        items: [item],
        sections: 'cart-drawer',
        sections_url: window.location.pathname
    };
}

function applyQuickViewSellingPlan(form, formData) {
    if (!form.closest('[data-hb-quick-view]')) {
        return;
    }

    var productRoot = form.closest('[data-hb-main-product]');
    var productId = productRoot
        ? String(productRoot.getAttribute('data-product-id') || '')
        : '';
    var variantId = String(formData.get('id') || '');
    var catalog = (window.HBQuickViewVariantPlans || {})[productId];
    var variantPlans = catalog ? catalog[variantId] : null;
    var submitted = formData.getAll('selling_plan').map(function (value) {
        return String(value || '').trim();
    }).filter(Boolean);

    formData.delete('selling_plan');

    var planToSend = '';

    if (variantPlans) {
        submitted.some(function (planId) {
            if (variantPlans.planIds.indexOf(planId) !== -1) {
                planToSend = planId;
                return true;
            }
            return false;
        });

        if (!planToSend && variantPlans.requiresSellingPlan && variantPlans.planIds.length) {
            planToSend = variantPlans.planIds[0];
        }
    } else {
        var leakedPlans = pageSellingPlanIds(form);
        submitted.some(function (planId) {
            if (leakedPlans.indexOf(planId) === -1) {
                planToSend = planId;
                return true;
            }
            return false;
        });
    }

    if (planToSend) {
        formData.set('selling_plan', planToSend);
    }
}

document.addEventListener(
    'hb:quick-view:loaded',
    function (event) {

        var root =
            event.detail &&
            event.detail.container
                ? event.detail.container
                : document;

        var productUrl =
            event.detail &&
            event.detail.productUrl
                ? event.detail.productUrl
                : '';


        /*
         * The PDP markup was inserted AFTER
         * DOMContentLoaded, so initialize it now.
         * Give this copy its own form ids so the open
         * subscription product form does not capture it.
         */
        if (root !== document) {
            isolateQuickViewIds(root);
        }

        rememberQuickViewSellingPlans(root, productUrl);

        initProductForms(root);

        initVariantPickers(root);
    }
);

document.addEventListener('DOMContentLoaded', function () {

    initAnnouncementBar();

    initMobileMenu();

    initCartDrawer();

    initProductForms();

    initQuantitySteppers();

    initCartLineSync();

    initCartUpsells();

    initCartSubscriptionUpgrade();

    initAccordions();

    initGalleries();

    initVariantPickers();

    initPopup();

    initVideoModal();

    initRecommendations();

});

})();